<template>
    <!--fluid correspond à toute la largeur de l'espace disponible sur un container-->
    <!--w-100 correspond à toute la largeur de l'espace disponible sur un container-->
    <b-container fluid class="overflow-auto p-5">
        <template v-if="change" >
            <b-row class="justify-content-center" style="font-size:1.5rem">
                <h5 class="mt-2">Ordre(s) de Service</h5>
            </b-row>
            <b-row class="p-1 pb-2" style="font-size:1rem">
                L’OS récapitule les informations nécessaires au fournisseur et au Gestionnaire de Réseau de Distribution (GRD) concerné (ENEDIS, GRDF ou votre Entreprise Locale de Distribution) pour réaliser différente opération.<br/>
                Ajout, Retrait, modification d'un point de livraison.
            </b-row>
            <b-row class="p-1 pb-2" style="font-size:1rem">
                Commencez la création d'un nouvel OS en cliquant sur le bouton + ci-dessous.<br />
                Une fois que vous avez complété puis validé votre formulaire en ligne, voici les étapes qui suivent :
            </b-row>
            <b-row class="p-1 pb-2" style="font-size:1rem">
                La validation génère l’OS sous la forme d’un document PDF que vous devez télécharger signé et redéposer dans DCx.<br />
                Suite à ce dépot un mail est envoyé au fournisseur correspondant.
            </b-row>
            <b-row class="p-1">
                <b-button pill class="d-flex"><b-icon icon="plus"></b-icon>Nouvel OS</b-button>
            </b-row>
            <b-row>
                <b-table-simple hover small caption-top responsive>
                    <b-thead head-variant="dark">
                        <b-tr>
                            <b-th>Siret</b-th>
                            <b-th>Réalisation</b-th>
                            <b-th>Auteur</b-th>
                            <b-th>Modification</b-th>
                            <b-th>Nom PDL</b-th>
                            <b-th>Numéro RAE/PCE</b-th>
                            <b-th>Action</b-th>
                            <b-th>Fichier</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr class="text-left">
                            <b-td>21180022200013</b-td>
                            <b-td variant="success">Envoyé</b-td>
                            <b-td>Jacques Durant</b-td>
                            <b-td>12/02/2024</b-td>
                            <b-td>Eclairage Public</b-td>
                            <b-td>72</b-td>
                            <b-td>
                                <b-button @click="change=false" class="p-1">Edition</b-button>
                            </b-td>
                            <b-td>
                                <b-button class="p-1"><b-icon icon="file-pdf"></b-icon></b-button>
                            </b-td>
                        </b-tr>
                        <b-tr class="text-left">
                            <b-td>21180022200015</b-td>
                            <b-td variant="warning">A validé</b-td>
                            <b-td>Jacquie Michel</b-td>
                            <b-td>01/01/2024</b-td>
                            <b-td>Eclairage Public</b-td>
                            <b-td>61</b-td>
                            <b-td>
                                <b-button class="p-1">Edition</b-button>
                            </b-td>
                            <b-td></b-td>
                        </b-tr>
                        <b-tr class="text-left">
                            <b-td>21180022200018</b-td>
                            <b-td>En attente</b-td>
                            <b-td>Vanessa Paradis</b-td>
                            <b-td>23/12/2023</b-td>
                            <b-td>Eclairage Public</b-td>
                            <b-td>85</b-td>
                            <b-td>
                                <b-button class="p-1">Edition</b-button>
                            </b-td>
                            <b-td></b-td>
                        </b-tr>
                        <b-tr class="text-left">
                            <b-td>21180022200018</b-td>
                            <b-td>En attente</b-td>
                            <b-td>Romain Duris</b-td>
                            <b-td>12/08/2023</b-td>
                            <b-td>Eclairage Public</b-td>
                            <b-td>69</b-td>
                            <b-td>
                                <b-button class="p-1">Edition</b-button>
                            </b-td>
                            <b-td></b-td>
                        </b-tr>
                    </b-tbody>
                    <b-tfoot>
                        <b-tr>
                            <b-td colspan="8" variant="secondary" class="text-left">
                                Total LIgnes: <b>5</b>
                            </b-td>
                        </b-tr>
                    </b-tfoot>
                </b-table-simple>
            </b-row>
        </template>
        <template v-else>
            <b-row class="justify-content-center">
                <h4 class="mt-2">Ordre de service pour le rattachement d’un point de livraison</h4>
            </b-row>
            <hr />
            <b-row class="p-1">
                <h5 class="mt-2">Rattachement PDL électricité</h5>
            </b-row>
            <b-row class="p-1 bg-gray">
                <h6 class="mt-2 font-italic">Informations liées au marché</h6>
            </b-row>
            <b-row class="p-1">
                <b-form-group class="w-100" label-cols="2" label="Référence du marché :">
                    <b-form-select>
                        <b-form-select-option :value="null">PC-20220728-5157004</b-form-select-option>
                    </b-form-select>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="Objet du marché : ">
                    <b-form-input disabled="true" value="Acheminement et fourniture d’électricité"></b-form-input>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="LOT concerné : ">
                    <b-form-input disabled="true" value="LOT 1 MS1"></b-form-input>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="Nom du titulaire du marché : ">
                    <b-form-input disabled="true" value="ENGIE"></b-form-input>
                </b-form-group>
            </b-row>
            <b-row class="p-1 bg-gray">
                <h6 class="mt-2 font-italic">Le demandeur</h6>
            </b-row>
            <b-row class="p-1">
                <b-form-group class="w-100" label-cols="2" label="Nom du membre : ">
                    <b-form-input value="BRIEC"></b-form-input>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="Adresse du membre :">
                    <b-form-input value="67 Rue du général De Gaulle 29510 Briec"></b-form-input>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="N° SIRET du membre : ">
                    <b-form-input value="21290020300010"></b-form-input>
                </b-form-group>
            </b-row>
            <b-row class="p-1 bg-gray">
                <h6 class="mt-2 font-italic">Personne sur site pour la mise en service</h6>
            </b-row>
            <b-row class="p-1">
                <b-form-group class="w-100" label-cols="2" label="Nom et prénom :">
                    <b-form-select>
                        <b-form-select-option :value="null">Gapihan Stéphanie</b-form-select-option>
                    </b-form-select>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="Téléphone :">
                    <b-form-input disabled="true" value="02 98 57 93 11"></b-form-input>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="Adresse mail :">
                    <b-form-input disabled="true" value="accueil@briec.bzh"></b-form-input>
                </b-form-group>
            </b-row>
            <b-row class="p-1 bg-gray">
                <h6 class="mt-2 font-italic">Informations associées à la facturation</h6>
            </b-row>
            <b-row class="p-1">
                <b-form-group class="w-100" label-cols="2" label="Nom et prénom :">
                    <b-form-select>
                        <b-form-select-option :value="null">Gapihan Stéphanie</b-form-select-option>
                    </b-form-select>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="Téléphone :">
                    <b-form-input disabled="true" value="02 98 57 93 11"></b-form-input>
                </b-form-group>
                <b-form-group class="w-100" label-cols="2" label="Adresse mail :">
                    <b-form-input disabled="true" value="21290020300010"></b-form-input>
                </b-form-group>
            </b-row>
        </template>
    </b-container>
</template>


<script lang="ts">
    import { Component, Vue } from 'vue-property-decorator';

    /** Fonction de l'espace de travail permet la création et le suivi des ordres de service du groupement d'achat */
    @Component({
        components: {
        }
    })
    export default class ServiceOrder extends Vue {
        private change: boolean = true;
    }

</script>

<style scoped>
</style>